main.animations = (function () {
    var initialised = false;
    var logo = document.getElementsByClassName('js-logo')[0];
    var logoStyles = window.getComputedStyle(logo);
    var initialLogoWidth;
    var maxLogoWidth;

    var init = function () {
        // only trigger svg animation on wider screens
        if (main.utils.viewport().width > 768) {
            _initSvgAnimations();
        }
        setLogoVariables();
    };

    _initSvgAnimations = function () {
        if (main.utils.isIE()) {
            return;
        }

        var svgs = document.getElementsByClassName('js-line-icon');
        if (svgs.length === 0) {
            return;
        }

        for (var i = 0, length1 = svgs.length; i < length1; i++){
            var svg = svgs[i].children[0];
            if (!svg) {
                return;
            }

            var path = svg.querySelector('path');

            if (!path) {
                return;
            }

            var pathLength = path.getTotalLength();
            //var animationDuration = '4500ms'
            var animationDuration = pathLength + 'ms';
            svg.style.strokeDasharray = pathLength;
            svg.style.strokeDashoffset = pathLength;
            svg.style.animationDuration = animationDuration;
        }

        function random(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }
    };

    var _initLogoVariables = function (scrollPosition) {
        if (initialised) { return; }
        // width of logo (incl. padding)
        //initialLogoWidth = parseInt(logoStyles.getPropertyValue('width'), 10);
        initialLogoWidth = document.getElementsByClassName('js-logo')[0].offsetWidth;
        initialised = true;
    };

    var setLogoVariables = function (scrollPosition) {
        _initLogoVariables();
        // width of container containing logo
        maxLogoWidth = document.getElementsByClassName(logo.dataset.wrapper)[0].offsetWidth;
    };

    var animateLogo = function (scrollPosition) {
        //var scrollPosition = Math.round(main.vars.scrollPercentage) / 100;
        // position
        var a = document.documentElement.scrollTop || window.pageYOffset;
        // maximum value for scrollTop
        var b = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        // percent of scroll [from 0 to 1]
        var scrollPos = a / b;
 
        var newLogoWidth = initialLogoWidth + ((maxLogoWidth - initialLogoWidth) * scrollPos);
        // set logo width
        logo.style.minWidth = initialLogoWidth + 'px';
        logo.style.maxWidth = maxLogoWidth + 'px';
        logo.style.width = newLogoWidth + 'px';
    };

    // check if browser is firefox
    if (/Firefox/i.test(navigator.userAgent)) {
        document.querySelector(".c-logo__firefox").style.display="block";
        document.querySelector(".c-logo__logo").style.display="none";
    }

    return {
        init: init,
        setLogoVariables: setLogoVariables,
        animateLogo: animateLogo,
    };
})();
